module.exports = __webpack_public_path__ + "static/media/closeGreen.e534bfce.svg";